import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "d-flex justify-content-center" }
const _hoisted_6 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "d-flex justify-content-center" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "d-flex justify-content-center" }
const _hoisted_12 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "d-flex justify-content-center" }

import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { checkMobile } from '../../utils/utils'
import Subscription from '../../../api/v2/models/subscription'
import { subscriptionState } from '../../stores/subscription'
import { userState } from '../../stores/user'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import { ROUTER_NAME } from '../../router'
import SubscriptionComponent from '../atoms_molecules/Subscription.vue'
import CoursePurchaseComponent from '../atoms_molecules/CoursePurchase.vue'
import TicketComponent from '../atoms_molecules/Ticket.vue'
import CoursePurchase from '../../../api/v2/models/course_purchase'
import axios from 'axios'

// Router

export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionList',
  setup(__props) {

const router = useRouter()

// Reactive state
const mobile = ref(false)
const tab = ref(0)
const tickets = ref<any[]>([])
const isLoadingTickets = ref(false)

// Computed properties
const user = computed(() => {
  return userState.user
})

const isLoading = computed(() => {
  return subscriptionState.isLoading || isLoadingTickets.value
})

const errorMessage = computed(() => {
  return subscriptionState.errorMessage
})

const subscriptions = computed((): Subscription[] => {
  if (!user.value) {
    return []
  }
  return user.value.subscriptions
})

const noneSubscriptions = computed((): boolean => {
  return subscriptions.value.length === 0
})

const coursePurchases = computed((): CoursePurchase[] => {
  if (!user.value) {
    return []
  }
  return user.value.coursePurchases
})

const nonecoursePurchases = computed((): boolean => {
  return coursePurchases.value.length === 0
})

const noneTickets = computed((): boolean => {
  return tickets.value.length === 0
})

// Breadcrumbs
const breadcrumbs = [
  {
    text: 'クラスルーム',
    disabled: false,
    exact: true,
    to: '/classroom/',
  },
  {
    text: '購入済み',
    disabled: false,
    exact: true,
    to: '/classroom/subscription',
  },
]

// Methods
const fetchTickets = async () => {
  try {
    isLoadingTickets.value = true
    const response = await axios.get('/api/v2/meeting/tickets')
    tickets.value = response.data.payment_tickets || []
    isLoadingTickets.value = false
  } catch (error) {
    console.error('Failed to fetch tickets:', error)
    isLoadingTickets.value = false
  }
}

const toSubscriptionDetail = (subscription: Subscription) => {
  router.push({
    name: ROUTER_NAME.SUBSCRIPTION_DETAIL,
    params: {
      subscriptionId: subscription.id.toString(),
    },
  })
}

const toCoursePurchaseDetail = (coursePurchase: CoursePurchase) => {
  router.push({
    name: ROUTER_NAME.COURSE_PURCHASE_DETAIL,
    params: {
      coursePurchaseId: coursePurchase.id.toString(),
    },
  })
}

// Lifecycle
onMounted(() => {
  mobile.value = checkMobile()
  headerState.setTitle('購入済み')
  footerState.setFooterDefault()
  fetchTickets()
})

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcrumb, { items: [
      { text: 'クラスルーム', to: '/classroom/' },
      { text: '購入済み' }
    ] }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_col, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs, {
            modelValue: tab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_v_tab, { key: 'ALL' }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("すべて", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })),
              (_openBlock(), _createBlock(_component_v_tab, { key: 'SUBSCRIPTION' }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("プレミアムサービス", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })),
              (_openBlock(), _createBlock(_component_v_tab, { key: 'COURSE' }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("コース一覧", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })),
              (_openBlock(), _createBlock(_component_v_tab, { key: 'TICKET' }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("チケット", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]),
          _createVNode(_component_v_divider, { class: "mt-2" }),
          _createVNode(_component_v_tabs_window, {
            modelValue: tab.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tabs_window_item, { value: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (isLoading.value || !noneSubscriptions.value || !nonecoursePurchases.value)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          lg: "12",
                          class: "p-7 bg-white"
                        }, {
                          default: _withCtx(() => [
                            (errorMessage.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(errorMessage.value), 1 /* TEXT */))
                              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subscriptions.value, (subscription, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: 'subscription-' + index
                                    }, [
                                      _createVNode(SubscriptionComponent, {
                                        subscription: subscription,
                                        class: _normalizeClass(index > 0 && 'mt-7'),
                                        onClick: ($event: any) => (toSubscriptionDetail(subscription))
                                      }, null, 8 /* PROPS */, ["subscription", "class", "onClick"]),
                                      _createVNode(_component_v_divider, { class: "mt-7" })
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coursePurchases.value, (coursePurchase, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: 'course-' + index
                                    }, [
                                      _createVNode(CoursePurchaseComponent, {
                                        coursePurchase: coursePurchase,
                                        class: _normalizeClass(index > 0 && 'mt-7'),
                                        onClick: ($event: any) => (toCoursePurchaseDetail(coursePurchase))
                                      }, null, 8 /* PROPS */, ["coursePurchase", "class", "onClick"]),
                                      _createVNode(_component_v_divider, { class: "mt-7" })
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ])),
                            _createElementVNode("div", _hoisted_5, [
                              (isLoading.value)
                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                    key: 0,
                                    indeterminate: "",
                                    color: "green",
                                    class: "loading"
                                  }))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode(" プレミアムサービス登録されていません ", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }))
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_v_tabs_window_item, { value: 1 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (isLoading.value || !noneSubscriptions.value)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          lg: "12",
                          class: "p-7 bg-white"
                        }, {
                          default: _withCtx(() => [
                            (errorMessage.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(errorMessage.value), 1 /* TEXT */))
                              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subscriptions.value, (subscription, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: 'sub-' + index
                                    }, [
                                      _createVNode(SubscriptionComponent, {
                                        subscription: subscription,
                                        class: _normalizeClass(index > 0 && 'mt-7'),
                                        onClick: ($event: any) => (toSubscriptionDetail(subscription))
                                      }, null, 8 /* PROPS */, ["subscription", "class", "onClick"]),
                                      _createVNode(_component_v_divider, { class: "mt-7" })
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ])),
                            _createElementVNode("div", _hoisted_8, [
                              (isLoading.value)
                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                    key: 0,
                                    indeterminate: "",
                                    color: "green",
                                    class: "loading"
                                  }))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode(" プレミアムサービス登録されていません ", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }))
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_v_tabs_window_item, { value: 2 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (isLoading.value || !nonecoursePurchases.value)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          lg: "12",
                          class: "p-7 bg-white"
                        }, {
                          default: _withCtx(() => [
                            (errorMessage.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(errorMessage.value), 1 /* TEXT */))
                              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coursePurchases.value, (coursePurchase, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: 'cp-' + index
                                    }, [
                                      _createVNode(CoursePurchaseComponent, {
                                        coursePurchase: coursePurchase,
                                        class: _normalizeClass(index > 0 && 'mt-7'),
                                        onClick: ($event: any) => (toCoursePurchaseDetail(coursePurchase))
                                      }, null, 8 /* PROPS */, ["coursePurchase", "class", "onClick"]),
                                      _createVNode(_component_v_divider, { class: "mt-7" })
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ])),
                            _createElementVNode("div", _hoisted_11, [
                              (isLoading.value)
                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                    key: 0,
                                    indeterminate: "",
                                    color: "green",
                                    class: "loading"
                                  }))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode(" 購入講座がありません ", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }))
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_v_tabs_window_item, { value: 3 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (isLoading.value || !noneTickets.value)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          lg: "12",
                          class: "p-7 bg-white"
                        }, {
                          default: _withCtx(() => [
                            (errorMessage.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(errorMessage.value), 1 /* TEXT */))
                              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tickets.value, (ticket, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: 'ticket-' + index
                                    }, [
                                      _createVNode(TicketComponent, {
                                        ticket: ticket,
                                        class: _normalizeClass(index > 0 && 'mt-7')
                                      }, null, 8 /* PROPS */, ["ticket", "class"]),
                                      _createVNode(_component_v_divider, { class: "mt-7" })
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ])),
                            _createElementVNode("div", _hoisted_14, [
                              (isLoading.value)
                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                    key: 0,
                                    indeterminate: "",
                                    color: "green",
                                    class: "loading"
                                  }))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode(" 購入チケットがありません ", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }))
                  ])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}
}

})